import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45 45"
    style={{
      enableBackground: "new 0 0 45 45",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path fill={props.background} d="M20.4 34.2c-.4 0-.8.3-.8.8v2.7h-6.8v-6.8h5.5c.4 0 .8-.3.8-.8s-.3-.8-.8-.8h-6.2c-.4 0-.8.3-.8.8v8.3c0 .4.3.8.8.8h8.3c.4 0 .8-.3.8-.8V35c0-.5-.4-.8-.8-.8z" />
    <path fill={props.background} d="M22.3 29.6c-.3-.3-.8-.3-1.1 0l-5 5-1.4-1.6c-.3-.3-.8-.3-1.1 0s-.3.8 0 1.1l2.1 2.1c.1.1.3.2.5.2s.4-.1.5-.2l5.5-5.5c.3-.4.3-.9 0-1.1zM12.2 25.3h8.3c.4 0 .8-.3.8-.8v-8.3c0-.4-.3-.8-.8-.8h-8.3c-.4 0-.8.3-.8.8v8.3c0 .5.3.8.8.8zm.7-8.3h6.8v6.8h-6.8V17zM32.8 33.5h-9.7c-.4 0-.8.3-.8.8s.3.8.8.8h9.7c.4 0 .8-.3.8-.8s-.3-.8-.8-.8zM32.8 19.7h-9.7c-.4 0-.8.3-.8.8s.3.8.8.8h9.7c.4 0 .8-.3.8-.8s-.3-.8-.8-.8z" />
    <path fill={props.background} d="M35.3 4.5h-4.6c-.3-.8-1.1-1.4-2-1.4h-3.4c-.7-.9-1.7-1.4-2.8-1.4-1.1 0-2.1.5-2.8 1.4h-3.4c-.9 0-1.7.6-2 1.4H9.7C8.4 4.5 7.3 5.6 7.3 7v33.7c0 1.4 1.1 2.5 2.5 2.5h25.6c1.4 0 2.5-1.1 2.5-2.5V7c-.2-1.4-1.3-2.5-2.6-2.5zm-19.6.8c0-.3.3-.6.6-.6h3.8c.3 0 .5-.1.6-.4.4-.6 1-1 1.7-1s1.4.4 1.7 1c.1.2.4.4.6.4h3.8c.3 0 .6.3.6.6v.6H15.7v-.6zm20.5 35.4c0 .6-.4 1-1 1H9.7c-.5 0-1-.5-1-1V7c0-.6.4-1 1-1h4.4v.6c0 .4.3.8.8.8h15.2c.4 0 .8-.3.8-.8V6h4.4c.5 0 1 .5 1 1v33.7z" />
  </svg>
)

export default SvgComponent
